export default "__VITE_ASSET__8c6c3084__"